import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Link from "next/link";
import getEmailUsUrl from "@/utils/getEmailUsUrl";
import ContactChat from "./contact-chat/ContactChat";
import ContactEmail from "./contact-email/ContactEmail";
import styles from "./contact-methods.module.scss";
import ContactPhone from "./contact-phone/ContactPhone";

const getComponent = (newDesign, contact, solutionId, isChatSupported, location, contactDetails, size) => {
  if (contact.name === "phone") {
    return (
      <ContactPhone
        key={contact.name}
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
        )}
        config={contactDetails.phone}
        solutionId={solutionId}
      />
    );
  }

  if (contact.name === "chat" && isChatSupported) {
    return (
      <ContactChat
        key={contact.name}
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
        )}
        config={contactDetails.chat}
        location={location}
      />
    );
  }

  if (contact.name === "chat-unavailable" && isChatSupported) {
    return (
      <div
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
        )}
        key={contact.name}
        data-test="container-chat-unavailable"
        style={{ display: "grid", "place-content": "center" }}
      >
        <h4 style={{ "font-size": "16px", "line-height": "22px", "font-weight": "700", "margin-bottom": "0" }}>
          Live chat unavailable
        </h4>
      </div>
    );
  }
  if (contact.name === "email" || (contact.name === "chat" && !isChatSupported)) {
    return (
      <ContactEmail
        key={contact.name}
        className={classnames(
          styles.cm__container,
          newDesign ? styles["cm__container--new"] : null,
          size === 1 ? styles.cmContainerOneItem : null,
        )}
        config={contactDetails.email}
        location={location}
      />
    );
  }
  return null;
};

function ContactMethods({ newDesign, fields, solutionId, location, contactDetails, subHeader }) {
  const methods = contactDetails
    ? fields.map(contact => getComponent(newDesign, contact, solutionId, true, location, contactDetails, fields.length))
    : null;

  return (
    <div className={classnames(styles.cm, fields.length === 1 ? styles.oneItem : null)}>
      {newDesign && <div className={styles.cm__subheader}>{subHeader}</div>}
      {methods}
      {contactDetails.email?.open ? (
        <p className={styles.cm__email}>
          Please note: if you prefer to <Link href={getEmailUsUrl(location)}>email us</Link>, it may take up to 24 hours
          for a response and longer for us to resolve your query. We recommend phone or chat for a quicker response and
          resolution.
        </p>
      ) : null}
    </div>
  );
}

ContactMethods.propTypes = {
  newDesign: PropTypes.bool,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      values: PropTypes.arrayOf(PropTypes.string),
    }),
  ),
  solutionId: PropTypes.string,
  location: PropTypes.string,
  contactDetails: PropTypes.shape({
    phone: PropTypes.objectOf(PropTypes.any).isRequired,
    chat: PropTypes.objectOf(PropTypes.any).isRequired,
    email: PropTypes.shape({
      open: PropTypes.bool,
    }),
  }),
  subHeader: PropTypes.string,
};

ContactMethods.defaultProps = {
  newDesign: false,
  fields: [],
  solutionId: null,
  location: undefined,
  contactDetails: {},
  subHeader: "If you still need help our Partners will try their best to help",
};

export default ContactMethods;
